import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const listPreviewEvents = {
  name: "listPreviewEvents" as const,
  input: z.object({
    schemaType: createEnum(SchemaType, { enumName: "SchemaType" }),
    limit: z.number().int().positive().max(10).optional(),
  }),
  output: z.array(
    z.object({
      eventId: z.string(),
      eventName: z.string(),
      timestamp: z.date(),
    }),
  ),
};
